function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import SettingItem from "@common/components/Settings/SettingItem";
import SettingsModalContentWrapper from "@common/components/Settings/SettingsModalContentWrapper";
import { changeWebSetting } from "@common/utils/helpers";
import { LAYOUT_DIRECTIONS } from "@config/constants";
var ChangeView = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(ChangeView, SettingItem);
    var _super = _create_super(ChangeView);
    function ChangeView(props) {
        _class_call_check(this, ChangeView);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "onChangeHandler", function(event) {
            var _this_props = _this.props, profileSettings = _this_props.profileSettings, onChangeHandler = _this_props.onChangeHandler;
            var layoutDirection = event.target.value;
            _this.setState({
                layoutDirection: layoutDirection
            });
            var isVerticalLayout = layoutDirection === LAYOUT_DIRECTIONS.vertical;
            onChangeHandler(changeWebSetting(profileSettings, {
                isVerticalLayout: isVerticalLayout
            }));
        });
        _this.state = {
            layoutDirection: _this.props.profileSettings.web_settings.isVerticalLayout ? LAYOUT_DIRECTIONS.vertical : LAYOUT_DIRECTIONS.horizontal
        };
        return _this;
    }
    _create_class(ChangeView, [
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                var verticalLabel = /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "label-name",
                            children: i18n.settings.vertical
                        }),
                        /*#__PURE__*/ _jsx("img", {
                            src: "/assets/media/layout-".concat(LAYOUT_DIRECTIONS.vertical, ".png"),
                            alt: "".concat(LAYOUT_DIRECTIONS.vertical, " layout")
                        })
                    ]
                });
                var horizontalLabel = /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "label-name",
                            children: i18n.settings.horizontal
                        }),
                        /*#__PURE__*/ _jsx("img", {
                            src: "/assets/media/layout-".concat(LAYOUT_DIRECTIONS.horizontal, ".png"),
                            alt: "".concat(LAYOUT_DIRECTIONS.horizontal, " layout")
                        })
                    ]
                });
                return /*#__PURE__*/ _jsx(SettingsModalContentWrapper, {
                    title: i18n.settings.selectView,
                    children: /*#__PURE__*/ _jsxs(RadioGroup, {
                        "aria-label": "layout-directions-group",
                        name: "layout-directions",
                        className: "radio-group layout-directions-wrapper",
                        value: this.state.layoutDirection,
                        onChange: this.onChangeHandler,
                        children: [
                            /*#__PURE__*/ _jsx(FormControlLabel, {
                                value: LAYOUT_DIRECTIONS.vertical,
                                className: "radio-label",
                                control: /*#__PURE__*/ _jsx(Radio, {}),
                                label: verticalLabel
                            }),
                            /*#__PURE__*/ _jsx(FormControlLabel, {
                                value: LAYOUT_DIRECTIONS.horizontal,
                                className: "radio-label",
                                control: /*#__PURE__*/ _jsx(Radio, {}),
                                label: horizontalLabel
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return ChangeView;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings;
    return {
        i18n: i18n,
        profileSettings: profileSettings
    };
};
export default connect(mapStateToProps)(ChangeView);
